import React, { useState } from "react";
import { Storage } from "aws-amplify";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import {
  useDataProvider,
  useNotify,
  useRedirect,
  Button,
  Confirm,
} from "react-admin";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({ record, resource, className, ...props }) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { basePath } = props;

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setLoading(true);
    let toUpdateRecord = null;
    debugger;

    try {
      debugger;
      await Storage.remove(record.file.key);
      await dataProvider.delete(resource, {
        id: record.id,
        previousData: record,
      });

      notify("File deleted successfully", "success");
      redirect(basePath);
    } catch (err) {
      logError(
        "files:DeepDeleteButton:handleDelete:" + JSON.stringify(toUpdateRecord),
        err,
        notify,
      );
    }

    setLoading(false);
    setOpen(false);
  };

  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={loading}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={"Delete Confirmation"}
        content={"Are you sure you want to delete this File?"}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
